var CommentBox = React.createClass({
  propTypes: {
    onCommentSaved: React.PropTypes.func.isRequired,
    parentID: React.PropTypes.number,
    buttonLabel: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    sizeModifier: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      parentID: 0,
      buttonLabel: Labels.getLabel("Post Comment"),
      placeholder: Labels.getLabel("Comment on this solution")
    }
  },
  getInitialState() {
    return {
      isOpen: false,
      errorMsg: ""
    }
  },
  submitClicked(e, mentionsMenu) {
    e.preventDefault();

    let commentText = this.refs.commentsText.value;
    if (commentText.trim().length == 0) {
      return;
    }

    var tempMentionedUsersList = mentionsMenu.getMentionedUsersList();
    var mentionedUsersList = "";
    for(var i = 0; i < tempMentionedUsersList.length; i++) {
      if (!commentText.includes("@" + tempMentionedUsersList[i].username)) {
        tempMentionedUsersList.splice(i, 1);
        continue;
      }
      var mentionedUser = tempMentionedUsersList[i].userID + "-" + tempMentionedUsersList[i].userSource;
      if (!mentionedUsersList.includes(mentionedUser)) {
        mentionedUsersList += mentionedUser + ",";
      }
    }

    let comment = {
      text: commentText,
      parentID: this.props.parentID,
      mentionedUsersList: mentionedUsersList
    };

    let postCommentButton = $(e.currentTarget);
    $(postCommentButton).attr("disabled", true);

    RA.ViewKB.Comments.add(comment, res => {
      if (res.success) {
        this.resetForm();
        this.props.onCommentSaved(comment);
        mentionsMenu.resetMentionedUsersList();
      } else {
        this.setState({errorMsg: res.message ? res.message : Labels.getLabel("Unknown error")});
      }

      $(postCommentButton).removeAttr("disabled");
    });
  },
  resetForm() {
    this.refs.commentsText.value = "";
    this.setState({ errorMsg: "", isOpen: false });
  },
  entryFocused() {
    this.setState({isOpen: true});
  },
  entryBlurred() {
    if (!this.refs.commentsText.value.length) {
      this.resetForm();
    }
  },
  onTextChange(mentionsMenu, text, searchTerm, cursorPosition) {
    if(text.length !== 0) {
      mentionsMenu.onInput(text, searchTerm, cursorPosition);
    }
  },
  resetComment(mentionsMenu) {
    if(this.refs.commentsText != null) {
      this.refs.commentsText.value = "";
    }
    mentionsMenu.closeMenu();
  },
  render() {
    let mentionsMenu = new Mentionify(
      document.getElementById('textarea' + this.props.parentID),
      document.getElementById('menu' + this.props.parentID),
      resolveFn,
      replaceFn,
      menuItemFn
    );

    //setup before functions
    var typingTimer;                //timer identifier
    var doneTypingInterval = 1000;  //time in ms (1 second)
    var textareaID = '#textarea'+ this.props.parentID;

    $(textareaID).click((e) => {
      mentionsMenu.closeMenu()
    })

    //on keyup, start the countdown
    $(textareaID).keyup((e) => {
      // get keycode of current keypress event
      const code = (e.keyCode || e.which);
      // do nothing if it's an up or down arrow key
      if(code == 38 || code == 40) {
          return;
      }
      clearTimeout(typingTimer);
      const textID = textareaID.substr(1);
      const input = document.getElementById(textID);
      if (input.value) {
          const text = input.value;
          const cursorPosition = input.selectionStart;
          
          // Find @ before cursor position
          const textBeforeCursor = text.substring(0, cursorPosition);
          const atPosition = textBeforeCursor.lastIndexOf("@");
          
          if (atPosition !== -1) {  // If @ exists before cursor
              let isMentionTrigger = false;
              
              // Check if @ is first character or has space/newline before it
              if (atPosition === 0 || text[atPosition - 1] === " " || text[atPosition - 1] === "\n") {
                  // Check if this @ is the one being currently typed
                  const textBetweenAtAndCursor = text.substring(atPosition + 1, cursorPosition);
                  if (!textBetweenAtAndCursor.includes(" ")) {
                      isMentionTrigger = true;
                  }
              }
              
              if (isMentionTrigger) {
                  const searchTerm = text.substring(atPosition + 1, cursorPosition).trim();
                  typingTimer = setTimeout(() => 
                      this.onTextChange(mentionsMenu, input.value, searchTerm, cursorPosition), 
                      doneTypingInterval
                  );
              } else {
                  mentionsMenu.closeMenu();
              }
          } else {
              mentionsMenu.closeMenu();
          }
      } else {
          mentionsMenu.closeMenu();
      }
  });

    var mentionsMenuTextarea = document.getElementById(textareaID.substr(1));
    window.onclick = function(event) {
      if (event.target !== mentionsMenuTextarea) {
        if(mentionsMenu.menuRef !== null) {
          mentionsMenu.closeMenu();
        }
      }
    }

    let focusElements,
      errorItem,
      inputMod = "",
      inputWrapMod = "",
      userImageMod = " -md";

    if (this.props.sizeModifier == "sm") {
      inputMod = " -sm";
      inputWrapMod = " -sm";
      userImageMod = " -sm";
    }

    if (this.state.isOpen) {
      inputMod += " -open";
      focusElements = (
        <div className="comment-form__input-footer">
          <button type="submit" className="btn btn-primary btn-sm" onClick={(event) =>  this.submitClicked(event, mentionsMenu)}>{this.props.buttonLabel}</button>
        </div>
      );
    }

    if (this.state.errorMsg.length) {
      errorItem = (
        <div className="alert alert-danger">
          <strong>{Labels.getLabel("Error")}:</strong>{" " + this.state.errorMsg}
        </div>
      );
    }

    let profileImagePath = RA.ViewKB.user.profileImage;
    let avatarPath = RA.defaultAvatar(profileImagePath);
    let profileText = RA.ViewKB.user.profileText;

    const renderProfileImage = () => {
      if (RA.Utils.isNotBlank(profileImagePath)) {
        return (
            <div className={"pull-left comment-form__user-image user-image" + userImageMod}>
              <img src={Config.contextPath + avatarPath} alt="" className="user-image__avatar"/>
            </div>
        );
      } else if (RA.Utils.isNotBlank(profileText)) {
        return (
            <div className={"pull-left comment-form__user-image user-image" + userImageMod}>
              <span className="avatar-text-comment user-image__avatar">{profileText}</span>
            </div>
        );
      } else {
        return (
            <div className={"pull-left comment-form__user-image user-image" + userImageMod}>
              <img src={Config.contextPath + avatarPath} alt="" className="user-image__avatar"/>
            </div>
        );
      }
    }

    return (
      <form className="comment-form">
        {errorItem}
        {renderProfileImage()}
        <div className={"comment-form__input-wrap" + inputWrapMod}>
          <textarea id={"textarea" + this.props.parentID} className={"comment-form__input" + inputMod}
            placeholder={this.props.placeholder}
            onFocus={this.entryFocused}
            onBlur={this.entryBlurred}
            ref="commentsText">
          </textarea>
          <div id={"menu"+ this.props.parentID} className="menu" role="listbox"></div>
          {focusElements}
        </div>
      </form>
    );
  }
});